import React from 'react';
import '../styles/WeeklySchedule.css';
import clock_icon from '../assets/icons/clock.svg';

const WeeklySchedule = ({ schedule = [] }) => {
  const daysOrder = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  // Group schedule items by day
  const groupedByDay = schedule.reduce((acc, item) => {
    if (!acc[item.day]) {
      acc[item.day] = [];
    }
    acc[item.day].push(item);
    return acc;
  }, {});

  // Sort days according to the week order
  const sortedDays = Object.keys(groupedByDay).sort((a, b) => {
    return daysOrder.indexOf(a) - daysOrder.indexOf(b);
  });

  if (schedule.length === 0) {
    return null;
  }

  return (
    <div className="weekly-schedule">
      <h2>Our Service Schedule</h2>
      <div className="schedule-grid">
        {sortedDays.map((day) => (
          <div key={day} className="schedule-day">
            <h3 className="day-name">{day}</h3>
            <div className="day-services">
              {groupedByDay[day].map((item, index) => (
                <div key={index} className="service-item">
                  <div className="service-time">
                    <img src={clock_icon} alt="Clock" className="clock-icon" /> {item.time}
                  </div>
                  <div className="service-name">{item.name}</div>
                  {item.description && (
                    <div className="service-description">{item.description}</div>
                  )}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WeeklySchedule;